import { useActiveOrg } from '~/hooks/org'
import { BackendTransaction, OrgMember } from '~/types'

export function useCancelledBy(
  transaction: BackendTransaction,
): OrgMember | null {
  const { org } = useActiveOrg()
  if (!('cancelledByUserId' in transaction) || !transaction.cancelledByUserId)
    return null
  return (
    org?.members.find(({ id }) => id === transaction.cancelledByUserId) ?? null
  )
}
